/**
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2024 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * @file SidePanelStyles.jsx - A component that handles sidepanel styles.
 */

import { colors } from '../../constants/StyleConstants';

const { WHITE, SIDE_PANEL } = colors;

export const PANEL_WIDTH = {
  expanded: 240,
  collapsed: 80
};

export const iconSize = 24;

export const styles = {
  panelContainer: (expanded) => ({
    display: 'flex',
    flexDirection: 'row',
    background: SIDE_PANEL.BG_COLOR,
    color: WHITE,
    transition: 'width 0.3s ease',
    width: expanded ? PANEL_WIDTH.expanded : PANEL_WIDTH.collapsed,
    minHeight: 725,
    overflow: 'hidden',
    position: 'relative'
  }),

  panelContent: {
    padding: 1.5,
    flexGrow: 1
  },

  sideButton: {
    marginLeft: '0px !important',
    color: SIDE_PANEL.BUTTON_COLOR,
    minWidth: '180px',
    height: 40,
    px: 2,
    justifyContent: 'flex-start',
    textTransform: 'none',
    transition: 'minWidth 0.6s ease',
    '&:hover': {
      background: SIDE_PANEL.BUTTON_HOVER_COLOR
    },
    '&>span>svg.sidepanel': {
      width: '20px !important'
    },
    '&.Mui-disabled': {
      color: SIDE_PANEL.DISABLED_COLOR,
      backgroundColor: 'transparent',
      cursor: 'not-allowed'
    }
  },

  iconButton: {
    color: SIDE_PANEL.BUTTON_COLOR,
    width: 40,
    height: 40,
    px: 2,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justtifyContent: 'center',
    transition: 'width 0.6s ease',
    '&:hover': {
      background: SIDE_PANEL.BUTTON_HOVER_COLOR
    },
    '&>svg.sidepanel': {
      width: '24px !important'
    },
    '&.Mui-disabled': {
      color: SIDE_PANEL.DISABLED_COLOR,
      backgroundColor: 'transparent',
      cursor: 'not-allowed'
    }
  },

  conditionalBox: (expanded, isActive) => ({
    mt: 3,
    p: 1,
    borderRadius: 1,
    bgcolor: isActive ? SIDE_PANEL.CONDITIONAL_BOX_BG_ACTIVE : SIDE_PANEL.CONDITIONAL_BOX_BG_INACTIVE,
    border: isActive
      ? `2px dashed ${SIDE_PANEL.CONDITIONAL_BOX_BORDER_ACTIVE}`
      : `2px solid ${SIDE_PANEL.CONDITIONAL_BOX_BORDER_INACTIVE}`,
    width: expanded ? 200 : 'fit-content'
  }),

  collapseToggle: {
    display: 'flex',
    alignItems: 'center',
    px: 0.5,
    position: 'absolute',
    bottom: 0,
    right: 0
  }
};
